import { UserProvider } from "src/hooks/useUser";
import Header from "./Header";
import { PrintClient } from "src/types";
import SourceTable from "../IncomeTable/SourceTable";
import Footer from "./Footer";

interface PrintProps {
  client: PrintClient;
  scenario: any;
}

const BySource = ({ client, scenario }: PrintProps) => {
  return (
    <UserProvider ignoreLogin>
      <Header client={client} scenario={scenario} page="Income By Type" />
      <Footer client={client} scenario={scenario} />
      <div className="px-5">
        <div>
          <SourceTable
            print
            client={client}
            scenario={scenario}
            selectedYear={0}
            setSelectedYear={() => { }}
            selectedColumn={{ id: 0, type: "none" }}
            setSelectedColumn={() => { }}
          />
        </div>
      </div>
    </UserProvider>
  );
};

export default BySource;
